import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName, getScopeName, getViewName } from '../../utils/nameFormat';
const productForm = getFormName('Product');
export const removeFormStmtInstruction = `
#### Remove form from scope
Use this command to remove a form from a specific scope. This command is designed to enhance the representation of user interfaces that require repetitive and variable user input structures.

- Syntax: \`remove form <form_name> in <view_name>.<scope_name>;\`
- Example: \`remove form ${productForm} in ${getViewName({ entityName: 'Product', viewType: 'create' })}.${getScopeName({ entityName: 'Product' })};\`
- Example: \`remove form ${productForm} in ${getViewName({ entityName: 'Product', viewType: 'edit' })}.${getScopeName({ entityName: 'Product' })};\`

#### Remove form
Use this command to remove a form from the application structure. This command will remove the form and all its elements from the structure.

- Syntax: \`remove form <form_name>;\`
- Example: \`remove form ${productForm};\`
`;
export const stmtRemoveForm = ({ formName, viewName, scopeName }) => {
    if (viewName && scopeName) {
        return `remove form ${formName} in ${viewName}.${scopeName};`;
    }
    return `remove form ${formName};`;
};
export const removeFormHandler = createStructureStatementHandler({
    type: 'remove form',
    parse: line => {
        const match = /^remove form (?<formName>\w+)( in (?<viewName>\w+).(?<scopeName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove form',
                scopeName: match.groups.scopeName,
                viewName: match.groups.viewName,
                formName: match.groups.formName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeForm({
                formName: stmt.formName,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
            });
        });
    },
});
//# sourceMappingURL=RemoveFormStmt.js.map